import { Component, Input } from '@angular/core';
import * as _ from 'lodash';
import { EMAIL_ADDRESS, PHONE_ADDRESSES, WEB_ADDRESSES } from 'app/cs/psv/common/model/person/address-constants';
import { EAddress } from 'app/cs/psv/common/model/person/psvPersonProfile';

@Component( {
    selector: 'psv-person-detail-view-contactdata',
    templateUrl: './person-detail-view-contactdata.component.html',
    preserveWhitespaces: false,
    standalone: false
} )
export class PersonDetailViewContactDataComponent {

    @Input() eAddresses: EAddress[];

    constructor() { }

    isEmpty( input: any ): boolean {
        return _.isNil( input ) || _.isEmpty( input );
    }

    // getter ------------------------------------------------------------------------------------------
    getEAddressTypeMail( addresses: EAddress[] ) {
        return addresses.filter( address => {
            return address.type.hiskeyId === EMAIL_ADDRESS;
        } );
    }

    getEAddressTypePhone( addresses: EAddress[] ) {
        return addresses.filter( address => {
            return PHONE_ADDRESSES.indexOf( address.type.hiskeyId ) > -1;
        } );
    }

    getEAddressTypeWeb( addresses: EAddress[] ) {
        return addresses.filter( address => {
            return WEB_ADDRESSES.indexOf( address.type.hiskeyId ) > -1;
        } );
    }
}
